const navDropdown = [...document.querySelectorAll('.js-nav-dropdown')];

// get vendor transition property
const docElemStyle = document.documentElement.style;
const transitionProp =
    typeof docElemStyle.transition == 'string' ? 'transition' : 'WebkitTransition';

navDropdown.forEach((dropdown) => {
    const navItems = [...dropdown.querySelectorAll('.js-nav-item')];
    navItems.forEach((item, index) => {
        item.style[transitionProp + 'Delay'] = index * 100 + 'ms';
    });
});
